export default "__VITE_ASSET__DjvUu5h1__"